import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import { LenisProvider } from "@/hooks/LenisProvider";

export default function Layout() {
  return (
    <LenisProvider>
      <div className="min-h-screen bg-[#FAFAFC] font-body">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </LenisProvider>
  );
}
